import get from 'lodash-es/get';
import isEmpty from 'lodash-es/isEmpty';
import keys from 'lodash-es/keys';
import mapKeys from 'lodash-es/mapKeys';
import pick from 'lodash-es/pick';

export const inviteCsvTemplateData = [
  [
    'email (required)',
    'first_name (required)',
    'last_name (required)',
    ' organization_name',
    'job_title',
    'school',
    'program',
    'class_of',
    'role',
    'interests',
    'searchable',
    'inviteable',
    'introductions',
    'offerings',
    'seeking',
    'about',
    'location',
    'website',
    'locale',
    'permissions',
  ],
  ['jane@10kcoffees.com', 'Jane', 'Doe'],
  ['john@10kcoffees.com', 'John', 'Doe'],
];
export const customSegmentCsvTemplateMap = {
  Item: 'name',
};
export const customSegmentAddRulesCsvTemplateMap = {
  Name: '0',
  'Gets introduced to': '1',
};
export const customSegmentDeleteRulesCsvTemplateMap = {
  Name: '0',
  'Does not get introduced to': '1',
};
export const matchSegmentAddRulesCsvTemplateMap = {
  Name: 'value',
  'Gets introduced to': 'match_with',
};
export const matchSegmentDeleteRulesCsvTemplateMap = {
  Name: 'value',
  'Does not get introduced to': 'match_with',
};
export const baseProfileCsvHeaderMap = {
  _id: '_id',
  email: 'email',
  first_name: 'first_name',
  invite_email_campaigns: 'opt_in.invite_email_campaigns',
  last_name: 'last_name',
  job_title: 'experience.0.job_title',
  organization_name: 'experience.0.organization_name',
  school: 'education.0.school',
  program: 'education.0.program',
  class_of: 'education.0.class_of',
  status: 'status',
  role: 'groups.role',
  interests: 'groups.industries',
  searchable: 'groups.searchable',
  inviteable: 'groups.inviteable',
  introductions: 'groups.opted_into_matchmaking',
  offerings: 'groups.offerings',
  seeking: 'groups.seeking',
  about: 'about',
  location: 'geo_location.0.address',
  website: 'website',
  photo: 'portrait_original_url',
  pronouns: 'pronouns',
  locale: 'locale_config.locale_selected',
  permissions: 'permissions',
};
export const rolesCsvTemplateMap = {
  Role: 'name',
  'Receives introductions': 'opted_into_matchmaking',
  'Accepts invitations': 'inviteable',
  'Appears on members search': 'searchable',
};
export const customSegmentItemsCsvTemplateData = [
  keys(customSegmentCsvTemplateMap),
  ['Example option 1'],
  ['Example option 2'],
  ['Example option 3'],
];
export const roleCsvTemplateData = [
  keys(rolesCsvTemplateMap),
  ['Example Role 1', 'true', 'true', 'true'],
  ['Example Role 2', 'false', 'true', 'false'],
  ['Example Role 3', 'true', 'false', 'true'],
];
export const reminderInviteCsvTemplateData = [
  ['email'],
  ['jane@10kcoffees.com'],
];
export const matchSegmentRulesAddCsvTemplateData = [
  ['Name', 'Gets introduced to', 'How to fill this out:'],
  [
    'Faculty 1',
    'Faculty 1',
    'In Column A enter all the roles in your introductions configuration',
  ],
  [
    'Faculty 1',
    'Faculty 2',
    'In Column B enter all the roles you want to add intro rules for - with respect to the role in Column A',
  ],
  ['Faculty 1', 'Faculty 3'],
];
export const matchSegmentRulesDeleteCsvTemplateData = [
  ['Name', 'Does not get introduced to', 'How to fill this out:'],
  [
    'Faculty 1',
    'Faculty 1',
    'In Column A enter all the roles in your introductions configuration',
  ],
  [
    'Faculty 1',
    'Faculty 2',
    'In Column B enter all the roles you want to delete intro rules for - with respect to the role in Column A',
  ],
  ['Faculty 1', 'Faculty 3'],
];
export const customSegmentRulesAddCsvTemplateData = [
  ['Name', 'Gets introduced to', 'How to fill this out:'],
  [
    'Faculty 1',
    'Faculty 1',
    'In Column A enter all the custom segments in your introductions configuration',
  ],
  [
    'Faculty 1',
    'Faculty 2',
    'In Column B enter all the custom segments you want to add intro rules for - with respect to the custom segment in Column A',
  ],
  ['Faculty 1', 'Faculty 3'],
];
export const customSegmentRulesDeleteCsvTemplateData = [
  ['Name', 'Does not get introduced to', 'How to fill this out:'],
  [
    'Faculty 1',
    'Faculty 1',
    'In Column A enter all the custom segments in your introductions configuration',
  ],
  [
    'Faculty 1',
    'Faculty 2',
    'In Column B enter all the custom segments you want to delete intro rules for - with respect to the custom segment in Column A',
  ],
  ['Faculty 1', 'Faculty 3'],
];
export const accountsDeleteCsvTemplateData = [
  ['email'],
  ['jane@10kcoffees.com'],
];

export enum DownloadCsvTemplateType {
  'accountsDelete' = 'accountsDelete',
  'customSegment' = 'customSegment',
  'customSegmentRulesAdd' = 'customSegmentRulesAdd',
  'customSegmentRulesDelete' = 'customSegmentRulesDelete',
  'invite' = 'invite',
  'matchSegmentRulesAdd' = 'matchSegmentRulesAdd',
  'matchSegmentRulesDelete' = 'matchSegmentRulesDelete',
  'membersRemove' = 'membersRemove',
  'profile' = 'profile',
  'reminderInvite' = 'reminderInvite',
  'role' = 'role',
}

export const csvTemplateTitle = {
  [DownloadCsvTemplateType.accountsDelete]: 'Delete Accounts Template',
  [DownloadCsvTemplateType.customSegment]: 'Upload Segments Template',
  [DownloadCsvTemplateType.customSegmentRulesAdd]:
    'Upload Introduction Rules Template',
  [DownloadCsvTemplateType.customSegmentRulesDelete]:
    'Upload Introduction Rules Template',
  [DownloadCsvTemplateType.profile]: 'Upload Profiles Template',
  [DownloadCsvTemplateType.invite]: 'Ten Thousand Coffees Bulk Invite Template',
  [DownloadCsvTemplateType.reminderInvite]:
    'Ten Thousand Coffees Reminder Invite Template',
  [DownloadCsvTemplateType.matchSegmentRulesAdd]:
    'Upload Introduction Rules Template',
  [DownloadCsvTemplateType.matchSegmentRulesDelete]:
    'Upload Introduction Rules Template',
  [DownloadCsvTemplateType.membersRemove]: 'Remove Members from Hub Template',
  [DownloadCsvTemplateType.role]: 'Upload Roles Template',
};
export const csvTemplateKeysMap = {
  [DownloadCsvTemplateType.customSegment]: customSegmentCsvTemplateMap,
  [DownloadCsvTemplateType.customSegmentRulesAdd]:
    customSegmentAddRulesCsvTemplateMap,
  [DownloadCsvTemplateType.customSegmentRulesDelete]:
    customSegmentDeleteRulesCsvTemplateMap,
  [DownloadCsvTemplateType.matchSegmentRulesAdd]:
    matchSegmentAddRulesCsvTemplateMap,
  [DownloadCsvTemplateType.matchSegmentRulesDelete]:
    matchSegmentDeleteRulesCsvTemplateMap,
  [DownloadCsvTemplateType.role]: rolesCsvTemplateMap,
};
export const templates = {
  [DownloadCsvTemplateType.accountsDelete]: {
    data: accountsDeleteCsvTemplateData,
    title: csvTemplateTitle[DownloadCsvTemplateType.accountsDelete],
  },
  [DownloadCsvTemplateType.customSegment]: {
    data: customSegmentItemsCsvTemplateData,
    title: csvTemplateTitle[DownloadCsvTemplateType.customSegment],
  },
  [DownloadCsvTemplateType.customSegmentRulesAdd]: {
    data: customSegmentRulesAddCsvTemplateData,
    title: csvTemplateTitle[DownloadCsvTemplateType.customSegmentRulesAdd],
  },
  [DownloadCsvTemplateType.customSegmentRulesDelete]: {
    data: customSegmentRulesDeleteCsvTemplateData,
    title: csvTemplateTitle[DownloadCsvTemplateType.customSegmentRulesDelete],
  },
  [DownloadCsvTemplateType.invite]: {
    data: inviteCsvTemplateData,
    title: csvTemplateTitle[DownloadCsvTemplateType.invite],
  },
  [DownloadCsvTemplateType.matchSegmentRulesAdd]: {
    data: matchSegmentRulesAddCsvTemplateData,
    title: csvTemplateTitle[DownloadCsvTemplateType.matchSegmentRulesAdd],
  },
  [DownloadCsvTemplateType.matchSegmentRulesDelete]: {
    data: matchSegmentRulesDeleteCsvTemplateData,
    title: csvTemplateTitle[DownloadCsvTemplateType.matchSegmentRulesDelete],
  },
  [DownloadCsvTemplateType.membersRemove]: {
    data: accountsDeleteCsvTemplateData,
    title: csvTemplateTitle[DownloadCsvTemplateType.membersRemove],
  },
  [DownloadCsvTemplateType.reminderInvite]: {
    data: reminderInviteCsvTemplateData,
    title: csvTemplateTitle[DownloadCsvTemplateType.reminderInvite],
  },
  [DownloadCsvTemplateType.role]: {
    data: roleCsvTemplateData,
    title: csvTemplateTitle[DownloadCsvTemplateType.role],
  },
};

export function mapCsvTemplateKeys(items: any[], templateType: string) {
  return items.reduce((result, item) => {
    const templateMap = get(csvTemplateKeysMap, templateType);
    const pickKeys = keys(templateMap);
    const pickedItem = pick(item, pickKeys);
    return isEmpty(pickedItem)
      ? result
      : [
          ...result,
          {
            value: mapKeys(pickedItem, (value, key) => get(templateMap, key)),
          },
        ];
  }, []);
}
